import { VersionService } from '@agroone-front/shared'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, inject } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router'
import { environment } from '@front-app-environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { LoadingService } from './core/services/loading/loading.service'
import { LoadingScreenComponent } from './shared/loading-screen/components/loading-screen.component'

declare const dT_: { initAngularNg?: (http: HttpClient, headers: typeof HttpHeaders) => void }
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, LoadingScreenComponent],
})
export class AppComponent {
  private matIconRegistry = inject(MatIconRegistry)
  private sanitizer = inject(DomSanitizer)
  private router = inject(Router)
  private loadingService = inject(LoadingService)
  private translate = inject(TranslateService)
  private versionService = inject(VersionService)
  private http = inject(HttpClient)

  constructor() {
    if (typeof dT_ !== 'undefined' && dT_.initAngularNg) {
      dT_.initAngularNg(this.http, HttpHeaders)
    }

    this.versionService.checkForUpdates()

    // Init icons
    this.matIconRegistry.addSvgIconSet(this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/icon-set.svg'))

    this.translate.get('LOADING.DEFAULT').subscribe((value) => {
      this.loadingService.setLoading({
        message: value,
      })
    })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.setLoading({ loading: true })
      }
      if (event instanceof NavigationCancel || event instanceof NavigationEnd || event instanceof NavigationError) {
        this.loadingService.setLoading({ loading: false })
      }
    })
    this.loadExternalScript(environment.dynatraceScriptSrc)
  }

  private loadExternalScript(scriptUrl: string): void {
    if (!scriptUrl) {
      return
    }

    const scriptElement: HTMLScriptElement = document.createElement('script')
    scriptElement.src = scriptUrl
    scriptElement.type = 'text/javascript'
    document.body.appendChild(scriptElement)
  }
}
